// extracted by mini-css-extract-plugin
module.exports = {"categoryContainer":"_3Nz6Xf"};